export default __webpack_public_path__ + "static/media/cake-razer-redeem-voucher.03594a0d.svg";